<template>
    <div class="container text-white">
        <div class="row my-4 d-flex justify-content-center">
            <h2>{{ $t('index.ourProjects') }}</h2>
        </div>

        <div class="row">
            <div class="col-sm-4">
                <h3><a class="text-white" :href="kumirPath"><strong>{{ $t('index.kumir') }}</strong></a></h3>

                <p>
                    {{ $t('index.kumirDescription[0]') }}
                    {{ $t('index.kumirDescription[1]') }}
                    {{ $t('index.kumirDescription[2]') }}
                    {{ $t('index.kumirDescription[3]') }}
                </p>
            </div>

            <div class="col-sm-4">
                <h3><a class="text-white" :href="piktomirPath"><strong>{{ $t('index.piktomir') }}</strong></a></h3>

                <p>
                    {{ $t('index.piktomirDescription[0]') }}
                    {{ $t('index.piktomirDescription[1]') }}
                    {{ $t('index.piktomirDescription[2]') }}
                    {{ $t('index.piktomirDescription[3]') }}
                </p>
            </div>

            <div class="col-sm-4">
                <h3><a class="text-white" :href="mireraPath"><strong>{{ $t('index.mirera') }}</strong></a></h3>

                <p>
                    {{ $t('index.mireraDescription[0]') }}
                    {{ $t('index.mireraDescription[1]') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import Paths from './mixins/Paths';

    export default {
        name: 'Index',

        mixins: [
            Paths
        ]
    };
</script>
